export type Market =
  | "australia"
  | "new_zealand"
  | "usa"
  | "united_kingdom"
  | "europe"
  | "indonesia"
  | "japan"
  | "china"
  | "singapore"
  | "small_market"
  | "medium_market"
  | "big_market";

export const amlLookup: Record<Market, string> = {
  australia: "AUSTRAC",
  new_zealand: "FIU",
  usa: "FinCEN",
  united_kingdom: "NCA",
  europe: "FIU",
  indonesia: "PPATK",
  japan: "FSA",
  china: "AMLB",
  singapore: "CAD",
  small_market: "SM",
  medium_market: "MM",
  big_market: "BM",
};

export const amlLongLookup: Record<Market, string> = {
  australia: "Australian Transaction Reports and Analysis Centre",
  new_zealand: "Financial Intelligence Unit",
  usa: "Financial Crimes Enforcement Network",
  united_kingdom: "National Crime Agency",
  europe: "Financial Intelligence Unit",
  indonesia: "Financial Transaction Reports and Analysis Centre",
  japan: "Financial Services Agency",
  china: "Anti-Money Laundering Bureau",
  singapore: "Commercial Affairs Department",
  small_market: "SM",
  medium_market: "MM",
  big_market: "BM",
};

export const countryLookup: Record<Market, string> = {
  australia: "Australia",
  new_zealand: "New Zealand",
  usa: "USA",
  united_kingdom: "United Kingdom",
  europe: "Europe",
  indonesia: "Indonesia",
  japan: "Japan",
  china: "China",
  singapore: "Singapore",
  small_market: "Small Market",
  medium_market: "Medium Market",
  big_market: "Big Market",
};

export const competitionRegulatorLookup: Record<Market, string> = {
  australia: "ACCC",
  new_zealand: "CC",
  usa: "FTC & DOJ",
  united_kingdom: "CMA",
  europe: "DG COMP",
  indonesia: "KPPU",
  japan: "JFTC",
  china: "SAMR",
  singapore: "CCCS",
  small_market: "SM",
  medium_market: "MM",
  big_market: "BM",
};

export const competitionRegulatorLongLookup: Record<Market, string> = {
  australia: "Australian CompetitionRegulator and Consumer Commission",
  new_zealand: "Commerce Commission",
  usa: "Federal Trade Commission and Antitrust Division of the Department of Justice",
  united_kingdom: "CompetitionRegulator and Markets Authority",
  europe: "European Commission Directorate-General for CompetitionRegulator",
  indonesia: "Komisi Pengawas Persaingan Usaha",
  japan: "Japan Fair Trade Commission",
  china: "State Administration for Market Regulation",
  singapore: "CompetitionRegulator and Consumer Commission of Singapore",
  small_market: "SM",
  medium_market: "MM",
  big_market: "BM",
};
